<template>
  <div
    :style="getPreviewThemeCss"
    :class="['FormQuestionsContainer Dynamic', { 'ReadOnly': readOnly }]"
  >
    <template v-if="!readOnly">
      <draggable
        v-model="formQuestions"
        :disabled="screenHasQuestion"
        class="FormBuilder list-group"
        group="questions"
        :move="handleMove"
        draggable=".list-group-item"
        @change="handleAddQuestion"
      >
        <dynamic-question-renderer
          v-if="screenHasQuestion"
          :question="question"
          :screen="screen"
          class="list-group-item"
          @question-renderer:select="handleSelectQuestion"
          @question-renderer:replace="handleReplaceQuestion"
        />

        <template slot="header">
          <div
            v-if="!screenHasQuestion"
            class="NoQuestionsPlaceholder"
          >
            <span>Drag and drop a field from the categories to create a
              question</span>
          </div>
        </template>
      </draggable>
    </template>
    <template v-else>
      <div :class="[{ ReadOnly: readOnly }, 'FormBuilder list-group']">
        <dynamic-question-renderer
          v-if="screenHasQuestion"
          :question="question"
          :screen="screen"
          class="list-group-item"
          @question-renderer:select="handleSelectQuestion"
          @question-renderer:replace="handleReplaceQuestion"
        />
      </div>
    </template>
  </div>
</template>
<script>
import {
  mapState, mapMutations, mapActions, mapGetters,
} from 'vuex';
import Draggable from 'vuedraggable';
import DynamicQuestionRenderer from '../dynamic-question-renderer.vue';

export default {
  components: {
    Draggable,
    DynamicQuestionRenderer,
  },
  props: {
    screen: {
      type: Object,
      default() {
        return {};
      },
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mediaType: 'image',
      screens: [],
      ui: {
        showLayoutMenu: false,
        showMediaMenu: false,
        showAddLayoutMediaModal: false,
      },
    };
  },
  computed: {
    ...mapState('events', {
      event: (state) => state.event,
    }),
    ...mapState('forms', {
      questions: (state) => state.form.questions,
      selectedQuestion: (state) => state.selectedQuestion,
    }),
    ...mapGetters('themes', ['getPreviewThemeCss']),
    ...mapGetters('forms', ['dynamicFormQuestionList']),

    formQuestions: {
      get() {
        return this.questions;
      },
      set() {},
    },
    question() {
      return this.dynamicFormQuestionList[this.screen.questionVuexId];
    },
    isStatementTypeQuestion() {
      return this.question ? this.question.type === 'statement' : false;
    },
    screenHasQuestion() {
      return this.screen.questionVuexId !== null;
    },
    noQuestionSelected() {
      return this.selectedQuestion.index === undefined;
    },
  },
  methods: {
    ...mapMutations('forms', [
      'updateSelectedQuestion',
      'setFormQuestions',
      'setScreenLayoutType',
      'setCurrentScreenNumber',
      'addQuestionToScreen',
      'addFormScreen',
    ]),
    ...mapActions('forms', ['removeFormQuestion', 'removeDynamicFormScreen']),
    handleAddQuestion(ev) {
      const question = ev.added.element;

      this.addQuestionToScreen({
        screenNumber: this.screen.number,
        question,
      });
    },
    handleMove() {
      // Dynamic forms do not have drag reordering functionality
      return false;
    },
    handleSelectQuestion(question) {
      // Prevent the user from switching questions when another is open
      if (this.noQuestionSelected) this.updateSelectedQuestion(question);
    },
    handleReplaceQuestion(question) {
      this.$emit('web-form-renderer:replace', question);
    },

    handleSubmitButtonSelect() {
      if (this.noQuestionSelected) {
        const formButtonObject = {
          key: 'go_to_next_question_button_label',
          question_uuid: 'go_to_next_question_button_label',
          label: this.selectedQuestion.go_to_next_question_button_label,
          index: this.questions.length,
        };

        this.updateSelectedQuestion(formButtonObject);
      }
    },
  },
};
</script>
